import { CatalogService } from "./../services/catalog.service";
import { Catalog } from "./../models/catalog";
import { MessageService } from "../services/message.service";
import { Message } from "../common/message";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material";
import { ConfirmDeleteDialogComponent } from "../dialog/confirm-delete-dialog/confirm-delete-dialog.component";

let ELEMENT_DATA = [];

@Component({
  selector: "app-catalog",
  templateUrl: "./catalog.component.html",
  styleUrls: ["./catalog.component.scss"],
})
export class CatalogComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = [
    "SN",
    "name",
    "maintenance",
    "repeat",
    "actions",
  ];
  dataSource = new MatTableDataSource();
  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  powerTrains: any;
  resource: Catalog = new Catalog();

  maintenanceHoursList: number[] = [
    // 100,
    200, 400, 800, 1600, 4000, 6000, 10000,
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private service: CatalogService,
    private formBuilder: FormBuilder,
    private msg: MessageService
  ) {}

  ngOnInit() {
    this.setMessageForm();
    this.getResources();
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      name: ["", Validators.required],
      maintenance: ["", Validators.required],
      repeat: ["", Validators.required],
    });
  }

  getResources() {
    ELEMENT_DATA = [];
    this.service.getAll().subscribe((result) => {
      ELEMENT_DATA = ELEMENT_DATA.concat(result);
      this.updateDataSource();
    });
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  onSave() {
    this.submitted = true;

    if (!this.resource || !this.resource.maintenance) {
      return;
    }

    if (!this.resource || !this.resource.repeat) {
      return;
    }

    if (
      !this.resource ||
      (this.resource.name && this.resource.name.trim() == "")
    ) {
      return;
    }

    if (this.resource.id) {
      this.updateElement();
    } else {
      this.addElement();
    }
  }

  resetForm(ret?: boolean) {
    this.resource.reset();
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  addElement() {
    this.service.create(this.resource).subscribe((result) => {
      this.msg.alert(Message.SAVE);
      ELEMENT_DATA.push(result);
      this.updateDataSource();
      this.resetForm();
    });
  }

  updateElement() {
    this.service.update(this.resource).subscribe((result) => {
      this.msg.alert(Message.UPDATE);
      ELEMENT_DATA.forEach((elem, index) => {
        if (elem.id == this.resource.id) {
          ELEMENT_DATA.splice(index, 1, result);
          return;
        }
      });
      this.updateDataSource();
      this.resetForm(true);
    });
  }

  editElement(ele: Catalog) {
    this.isFormDisplay = true;
    this.isAddNew = false;
    this.resource.setId(ele.id);
    this.resource.setName(ele.name);
    this.resource.setMaintenance(ele.maintenance);
    this.resource.setRepeat(ele.repeat);
  }

  deleteElement(ele: Catalog) {
    this.dialog
      .open(ConfirmDeleteDialogComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result == "true") {
          this.service.delete(ele.id).subscribe((result) => {
            this.msg.alert(Message.DELETE);
            let index = ELEMENT_DATA.indexOf(ele);
            ELEMENT_DATA.splice(index, 1);
            this.updateDataSource();
          });
        } else {
          return;
        }
      });
  }
}
